export const soon = {
  title: "Come Back Later...",
  body: `<br />
    <h1>Hi, ini bukan tanggalnya!</h1>
    <br /><br /><br />
    <p style="font-size: 14px;">
    Ups! Website ini hanya untuk ulang tahun Twiska dan hanya bisa dibuka pada tanggal tersebut. Datang lagi nanti ya! 🌸
    </p>`,
};

export const late = {
  title: "See you next time...",
  body: `<br />
    <h1>Yahh, tanggalnya sudah lewat!</h1>
    <br /><br /><br />
    <p style="font-size: 14px;">
    Ups! Website ini hanya untuk ulang tahun Twiska dan hanya bisa dibuka pada tanggal tersebut. Datang lagi tahun depan ya! 🌸
    </p>`,
};
